import { render, staticRenderFns } from "./VendorPreview.vue?vue&type=template&id=9f62db20&scoped=true&"
import script from "./VendorPreview.vue?vue&type=script&lang=js&"
export * from "./VendorPreview.vue?vue&type=script&lang=js&"
import style0 from "./VendorPreview.vue?vue&type=style&index=0&id=9f62db20&prod&lang=scss&scoped=true&"
import style1 from "./VendorPreview.vue?vue&type=style&index=1&id=9f62db20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f62db20",
  null
  
)

export default component.exports